module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"segments":"Segments","noSegmentsAdded":"This workspace doesn\u0027t contain any segments yet","noSegmentsFound":"No matching segments found","addSegment":"Add segment"},"ru":{"segments":"Сегменты","noSegmentsAdded":"В этой рабочей области пока нет сегментов","noSegmentsFound":"Сегменты, соответствующие вашему запросу, не найдены","addSegment":"Добавить сегмент"}}')
  delete Component.options._Ctor
}
